import React from "react";
import { JsonForms } from "@jsonforms/react";
import {
  materialRenderers,
  readonlyRenderers,
} from "../../../jsonForms/materialRenderers.jsx";
import { materialCells } from "@jsonforms/material-renderers";

export default function HistoryRecord({ entry }) {
  const data = entry.data;
  const template = entry.template?.template;
  const schema = template?.schema;
  const uiSchema = template?.uiSchema;

  return (
    <JsonForms
      schema={schema}
      uischema={uiSchema}
      data={data}
      renderers={[...materialRenderers, ...readonlyRenderers]}
      cells={materialCells}
    />
  );
}
